import type { FC } from "react"
import { useTranslation } from "react-i18next"
import type { DateTime } from "luxon"

interface DateRangeTooltipContentProps {
  fromDate: DateTime
  toDate: DateTime
  /** Optional caption above the range, e.g. "Zoomed period". */
  header?: string
}

const DateRangeTooltipContent: FC<DateRangeTooltipContentProps> = ({
  fromDate,
  toDate,
  header,
}) => {
  const { t } = useTranslation()

  return (
    <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
      {header && <p style={{ marginBottom: 10 }}>{header}:</p>}
      <p>{fromDate.toFormat("yyyy-MM-dd HH:mm:ss")}</p>
      <p>{t("generic.TO").toLowerCase()}</p>
      <p>{toDate.toFormat("yyyy-MM-dd HH:mm:ss")}</p>
    </div>
  )
}

export default DateRangeTooltipContent
